(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/transfer-wager.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/transfer-wager.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.TransferWager = Backbone.Model.extend({
    log: new svs.core.log.Logger('svs.tipset.models.TransferWager'),

    initialize: function() {
      this.set(
        'id',
        svs.tipset.models.gameDefinitions.getAPIName(
          svs.tipset.collections.draws.getCurrentDraw().get('productId')
        ),
        { silent: true }
      );
      this.draws = new svs.tipset.collections.TransferDraws();
      this.listenTo(this.draws, 'sync', this.setHasDrawToTransfer);
      this.listenTo(
        svs.tipset.models.wager,
        'transferWager',
        this.saveTransferGame
      );
    },

    setHasDrawToTransfer: function() {
      this.setTransferGame();
      this.set('hasDrawToTransferTo', this.draws.any());
    },

    saveTransferGame: function(wager) {
      var transferToId,
        transferUrlAddOn = this.draws.first().get('urlAddOn'),
        boardsToTransfer = [];

      wager.bets = _.reject(wager.bets, function(bet) {
        return _.contains(bet, svs.tipset.constants.IS_SPORT_JOKER);
      });

      if (svs.tipset.models.play.get('isSingleRow')) {
        _.each(wager.bets[0].game1X2Boards, function(board) {
          boardsToTransfer.push(_.first(board.boardData, 8));
        });
      } else {
        boardsToTransfer.push(
          _.first(wager.bets[0].game1X2Boards[0].boardData, 8)
        );
      }

      switch (this.get('id')) {
        case 'STRYK':
          transferToId = 'T8STRYK';
          boardsToTransfer = this.removeMGMarks(boardsToTransfer);
          break;
        case 'T8STRYK':
          transferToId = 'STRYK';
          boardsToTransfer = this.addGamesToBoard(boardsToTransfer);
          break;
        case 'T8EXTRA':
          transferToId = 'ITA';
          boardsToTransfer = this.addGamesToBoard(boardsToTransfer);
          break;
        case 'ITA':
          transferToId = 'T8EXTRA';
          boardsToTransfer = this.removeMGMarks(boardsToTransfer);
          break;
        default:
          break;
      }

      boardsToTransfer = svs.tipset.models.play.get('isSingleRow')
        ? boardsToTransfer
        : boardsToTransfer[0];

      this.set(
        {
          id: transferToId,
          drawNumber: transferUrlAddOn,
          sportkryssBet: undefined,
          sportkryssIsValid: undefined,
          system: undefined,
          quickPick: 0,
          useBoardRow: '',
          boardData: boardsToTransfer,
          uRowData: undefined,
          isSingleRow: svs.tipset.models.play.get('isSingleRow') || false,
          numWeeks: 1,
          isTransferWager: true
        },
        { silent: true }
      );
      this.save();
    },

    save: function() {
      svs.tipset.objects.localstorageHandler.saveTransferWager();
    },

    addGamesToBoard: function(boardsToTransfer) {
      _.each(boardsToTransfer, function(board) {
        for (var i = 8; i < 13; i++) {
          board.push('0');
        }
      });

      return boardsToTransfer;
    },

    removeMGMarks: function(boardsToTransfer) {
      _.each(boardsToTransfer, function(board) {
        for (var i = 0; i < board.length; i++) {
          board[i] = board[i].replace('M', '');
        }
      });
      return boardsToTransfer;
    },

    setTransferGame: function() {
      var currentGameId = svs.tipset.models.gameDefinitions.getAPIName(
          svs.tipset.collections.draws.getCurrentDraw().get('productId')
        ),
        tempGameName,
        tempLink;

      switch (currentGameId) {
        case 'T8STRYK':
          tempGameName = 'Stryktipset';
          tempLink = '/stryktipset/spela/';
          break;
        case 'T8EXTRA':
          tempGameName = 'Europatipset';
          tempLink = '/europatipset/spela/';
          break;
        case 'STRYK':
        case 'ITA':
          tempGameName = 'Topptipset';
          tempLink = '/topptipset/spela/';
          break;
        default:
          break;
      }

      this.set(
        {
          gameName: tempGameName,
          link: tempLink
        },
        { silent: true }
      );
    },

    transferGame: function() {
      var url = this.get('link') + this.get('drawNumber');

      this.clear();
      window.location = url;
    }
  });
})(Backbone, _, svs);

 })(window);